import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import Loading from './components/utils/Loading';
import AdminHome from './components/admin/AdminHome'
import AdminLogin from './components/admin/AdminLogin'
import SetUpTickets from './components/admin/SetUpTickets';
import SetUpReveal from './components/admin/SetUpReveal';
import SetUpGame from './components/admin/SetUpGame';
import SetUpTeamVariables from './components/admin/SetUpTeamVariables';
import SetUpRulesAndRegs from './components/admin/SetUpRulesAndRegs';
import SetUpTicketEmail from './components/admin/SetUpTicketEmail';
import LoginVariables from './components/admin/SetUpLoginVariables';
import Scoreboard from './components/admin/Scoreboard';
import { app } from './base'

function AuthenticatedAdminRoute({component: Component, authenticated, scoreboardOnly, allowedRoutes, path, ...rest}) {
    return (
        <Route
            {...rest}
            render={(props) => {
                if(authenticated === true){

                    if (scoreboardOnly && path === "/setuproles") {
                        return <Redirect to="/" />;
                    }

                    return (
                        <Component scoreboardOnly={scoreboardOnly} {...props} {...rest} />
                    )
                } else {
                    return (
                        <Redirect to={{pathname: '/adminLogin', state: {from: props.location}}} />
                    )
                }
            }} />
    )
}

class App extends Component {
    constructor(props) {
        super(props)
        this.setCurrentUser = this.setCurrentUser.bind(this)
        this.state = {
            authenticated: false,
            currentUser: null,
            loading: true
        }
    }

    async setCurrentUser(user) {
        if (user) {
            try {
                const idTokenResult = await user.getIdTokenResult();
                let isSqwadEmployee = false;
                if(user.email.slice(user.email.lastIndexOf('@') + 1).toLowerCase() === 'sqwadhq.com'){
                    isSqwadEmployee = true;
                }
                const customClaims = idTokenResult.claims || {};
                const scoreboardOnly = customClaims.scoreboard || false;

                this.setState({
                    currentUser: user,
                    authenticated: true,
                    scoreboardOnly: scoreboardOnly,
                    isSqwadEmployee: isSqwadEmployee,
                    loading: false
                });
            } catch (error) {
                console.error('Error fetching custom claims:', error);
                this.setState({
                    currentUser: user,
                    authenticated: true,
                    loading: false
                });
            }
        } else {
            this.setState({
                currentUser: null,
                authenticated: false,
                loading: false
            });
        }
    }

    componentDidMount() {
        this.removeAuthListener = app.auth().onAuthStateChanged(async (user) => {
            if (user) {
                await this.setCurrentUser(user);
            } else {
                this.setState({
                    authenticated: false,
                    currentUser: null,
                    loading: false,
                })
            }
        })
    }

    componentWillUnmount() {
        this.removeAuthListener()
    }

    render() {
        const { authenticated, scoreboardOnly, loading, isSqwadEmployee } = this.state;
        if (loading === true) return <Loading loading={loading}/>

        return (
            <BrowserRouter>
              <Switch>
                <Route
                    exact
                    path="/adminlogin"
                    user={this.state.currentUser}
                    render={(props) => {
                      return <AdminLogin setCurrentUser={this.setCurrentUser} {...props} />
                    }} />

                <Route
                  exact
                  path="/scoreboard"
                  render={(props) => {
                      return <Scoreboard {...props} />
                  }} />

                <AuthenticatedAdminRoute
                    exact
                    path="/admin"
                    authenticated={authenticated}
                    scoreboardOnly={scoreboardOnly}
                    isSqwadEmployee={isSqwadEmployee}
                    component={AdminHome} />

                <AuthenticatedAdminRoute
                    exact
                    currentUser={this.state.currentUser}
                    path="/setupgame"
                    authenticated={authenticated}
                    scoreboardOnly={scoreboardOnly}
                    component={SetUpGame} />

                <AuthenticatedAdminRoute
                    exact
                    path="/setupreveals"
                    authenticated={authenticated}
                    component={SetUpReveal} />

                <AuthenticatedAdminRoute
                    exact
                    path="/setuptickets"
                    authenticated={authenticated}
                    component={SetUpTickets} />

                <AuthenticatedAdminRoute
                    exact
                    path="/setupteamvariables"
                    authenticated={authenticated}
                    component={SetUpTeamVariables} />

                <AuthenticatedAdminRoute
                    exact
                    path="/setuprulesandregs"
                    authenticated={authenticated}
                    component={SetUpRulesAndRegs} />

                <AuthenticatedAdminRoute
                    exact
                    path="/setupticketemail"
                    authenticated={authenticated}
                    component={SetUpTicketEmail} />

                <AuthenticatedAdminRoute
                      exact
                      path="/setuploginvariables"
                      authenticated={authenticated}
                      component={LoginVariables} />

                <Redirect to="/adminlogin"/>
              </Switch>
            </BrowserRouter>
        )
    }
}

export default App;
